import * as types from '../constants/ActionTypes';

export const initialState = {
  setContextIntents: [],
  setContextResponse: [],
  faq: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.SET_CONTEXT_INTENTS:
      return {
        ...state,
        setContextIntents: action.payload.intents,
        faq: action.payload.faq,
      };

    case types.SET_CONTEXT_RESPONSE:
      return {
        ...state,
        setContextResponse: action.payload,
      };

    case types.RESET_OCP_CONTACT_RESPONSE:
      return initialState;

    default:
      return state;
  }
}
